module.exports = __webpack_public_path__ + "img/price.31770b10.png";